import { Component } from '@angular/core';
import { _MSGTYPES } from '../../shared/constant/msgType';
import { MsgTemplateDetail } from '../../msg-interface/msg-template-detail';

@Component({
  selector: 'icc-voice-tpl-detail',
  templateUrl: './voice-tpl-detail.component.html',
  styleUrls: ['./voice-tpl-detail.component.less'],
})
export class VoiceTplDetailComponent implements MsgTemplateDetail {
  constructor() {}
  SCENE = 'icc-msg-tpl-detail';
  MSG_TYPE = _MSGTYPES.MT;

  data;

  type: number = _MSGTYPES.MT.VOICE.type;

  setData(item): void {
    this.data = item;
  }
}
